export const ghlLinkFreeConsultation = "https://freeconsultation.almadelic.com/get-started-complementary-consultation";
